var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","depressed":"","height":"30","color":"info","block":_vm.isMobile(),"large":_vm.isMobile()},on:{"click":function($event){return _vm.selecionarProdutos()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cart-plus")]),_vm._v(" Adicionar produto")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }